import { IS_DARK_THEME } from '../reducers/actionTypes';
export const setDarkThemeAndStore = (theme) => async (dispatch) => {
    dispatch(setDarkTheme(theme));
};

const setDarkTheme = (theme) => ({
    type: IS_DARK_THEME,
    payload: theme,
});
//correct